import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

function useProfile() {
  const profile = useSelector((store) => store.profile, shallowEqual);
  return profile;
}

export default useProfile;
